export default "__VITE_ASSET__cb505dc5__"